import React, { FC, ReactNode } from "react";
import { Flex } from "@UI/Components/Flex/Flex";
import { VStack } from "@UI/Components/Stack/Stack";
import { Button } from "@UI/Components/Button/Button";
import { CircleXmark } from "@UI/Components/Icons/CircleXmark";
import { Icon } from "@UI/Components/Icon/Icon";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { Text } from "@UI/Components/Text/Text";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";
import { Bold } from "@UI/Components/Bold/Bold";

interface Props {
  title: ReactNode;
  message?: ReactNode;
  children?: ReactNode;
}

export const PaymentError: FC<Props> = ({ title, message, children }) => {
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate("HOME", {
      reload: true,
    });
  };

  return (
    <VStack justifyContent="center" spacing="4" pb={{ base: 2, md: 9 }}>
      <Flex textAlign="center">
        <Icon as={CircleXmark} w="12" h="12" color="error" />
      </Flex>
      <Flex textAlign="center" flexDirection="column">
        <Text>
          <Bold>{title}</Bold>
        </Text>
        <Text>{message}</Text>
        {children}
      </Flex>
      <Button
        w="full"
        variant="outline"
        onClick={handleConfirm}
        size="lg"
        colorScheme="seaGreen"
        data-testid="complete-subscription"
      >
        <FormattedMessage {...messages.mydashboard} />
      </Button>
    </VStack>
  );
};
